import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import logo from 'styles/ciro_client_light.png';

export interface IHeaderDesktopProps {
    hospitalName: string | null;
    payPeriod: string | null;
}

const HeaderDesktop = (props: IHeaderDesktopProps): JSX.Element => (
    <Container fluid className="timesheet-table__container">
        <Row>
            <Col>
                <div className="logo mt-2 mb-2">
                    <img src={logo} alt="ciro client" />
                </div>
            </Col>
            <Col>
                <div className="h5 mb-0 hospital-name text-right">{props.hospitalName || ''} Timesheets</div>
                <div className="h5 mb-1 font-weight-300 text-right">
                    &nbsp;
                    {props.payPeriod ? `Pay period: ${props.payPeriod}` : ''}
                </div>
            </Col>
        </Row>
    </Container>
);

export default HeaderDesktop;
